module.exports = __webpack_public_path__ + "static/media/indian.402933f6.jpg";